import { Component, computed, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { injectDispatch } from '@ngrx/signals/events';
import { PortsStore } from '@navstation-portal/ports/data-access/store';
import { StockTankFormState } from '@navstation-portal/reporting/data-model/vessel-report';
import { portsToSelectOptions } from '@navstation-portal/ports/util/ports';
import {
  AbstractStoreConnectedSectionComponent,
  offshoreStockFormEvents,
  OffshoreStockFormStore,
} from '@navstation-portal/reporting/data-access/offshore-report';
import {
  StockTableComponent,
  TableColumn,
} from '../../../../shared/stock-table/stock-table.component';

@Component({
  selector: 're-in-use-tanks',
  templateUrl: './in-use-tanks.component.html',
  imports: [StockTableComponent, FormsModule],
})
export class InUseTanksComponent extends AbstractStoreConnectedSectionComponent {
  tabId = 'stock';
  sectionId = 'tanks';
  fieldId = 'tankRows';
  stockStore = inject(OffshoreStockFormStore);
  portStore = inject(PortsStore);
  events = injectDispatch(offshoreStockFormEvents);

  portOptions = computed(() => {
    return portsToSelectOptions(this.portStore.ports());
  });
  get columns(): TableColumn<StockTankFormState>[] {
    return [
      {
        header: 'Tank Name',
        field: 'tankName',
        type: 'rowTitle',
        title: 'fuel',
        subtitleField: 'tankCapacity',
        minWidth: '200px',
      },
      {
        header: 'Stock (MT)',
        field: 'amount',
        type: 'number',
        minWidth: '70px',

        requiredFunction: (tank: StockTankFormState) => this.isInUseTank(tank),
      },
      {
        header: 'Sulphur (%)',
        field: 'sulphurAfterBunkering',
        type: 'number',
        minWidth: '70px',
        readOnly: true,
      },
      {
        header: 'LCV (kJ/kg)',
        field: 'lcv',
        type: 'number',
        minWidth: '110px',
        readOnly: true,
      },
      {
        header: 'Density (kg/m³)',
        field: 'density',
        type: 'number',
        minWidth: '80px',
        readOnly: true,
      },
      {
        header: 'Viscosity (cSt)',
        field: 'viscosity',
        type: 'number',
        minWidth: '70px',
        readOnly: true,
      },
      {
        header: 'Fuel Grade',
        field: 'fuelGrade',
        type: 'select',
        options: this.reportStore.availableFuelGradeOptions(),
        minWidth: '120px',
        readOnly: true,
      },
      {
        header: 'Bunker Port',
        field: 'bunkerPort',
        type: 'autocomplete',
        options: this.portOptions(),
        bgColorField: 'groupColor',
        minWidth: '120px',
        readOnly: true,
      },
      {
        header: 'Bunker Date',
        field: 'bunkerDate',
        type: 'datepicker',
        readOnly: true,
        minWidth: '150px',
      },
    ];
  }

  isInUseTank(tank: StockTankFormState) {
    return (
      tank.inUse.value || !!tank.tankName.value?.match(/SERV|SETT|OVERFLOW/i)
    );
  }
}
